module.exports = __webpack_public_path__ + "static/media/down-arrow-small.2c67cece.svg";